<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title>
        Suggestions
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="ma-4" id="user-list">
      <v-simple-table>
        <thead>
          <tr>
            <th width="1%"></th>
            <th width="20%" class="text-left">Student name</th>
            <th width="50%" class="text-left">Suggestion</th>
            <th class="text-left">Added date</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="suggestions.data.length">
            <tr v-for="suggestion in suggestions.data" :key="suggestion.id">
              <td>
                <v-avatar class="ma-2" color="grey lighten-2" size="38">
                  <img :src="suggestion.user.avatar_thumb_url" alt="avatar" />
                </v-avatar>
              </td>
              <td>
                {{ suggestion.user.full_name }}
              </td>
              <td>
                {{ suggestion.suggestion }}
              </td>
              <td>{{ suggestion.createdAt }}</td>
            </tr>
          </template>
          <tr v-else>
            <td class="text-center headline grey--text py-10" colspan="4">
              No suggestions available.
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-overlay absolute :value="loading" opacity="0.1">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </div>
    <div v-if="suggestions.meta.last_page > 1" class="text-center mt-4">
      <v-pagination
        @input="pageChanged"
        :value="suggestions.meta.current_page"
        :length="suggestions.meta.last_page"
        :total-visible="10"
        circle
      />
    </div>
  </div>
</template>

<script>
import { mdiDotsVertical } from '@mdi/js'
import Suggestion from '@/models/Suggestion'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

export default {
  name: 'SuggestionsPage',

  components: {
    AppBarNavIcon
  },

  data() {
    return {
      loading: false,
      icons: {
        settings: mdiDotsVertical
      },
      suggestions: {
        data: [],
        meta: {
          current_page: 1
        }
      }
    }
  },

  methods: {
    pageChanged(page) {
      this.suggestions.meta.current_page = page
      this.getSuggestions()
    },

    getSuggestions() {
      this.loading = true
      return Suggestion.include('user')
        .limit(15)
        .page(this.suggestions.meta.current_page)
        .get()
        .then(response => {
          this.suggestions = response
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    }
  },

  created() {
    this.getSuggestions()
  }
}
</script>

<style></style>
